/**
 * Shared UI formatting utilities for Analytics.
 * Converts internal/backend values to user-facing labels.
 */

/** snake_case or kebab-case enum → "Title Case" label. */
export function humanizeEnum(value: string): string {
  return value
    .replace(/[_-]/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase())
    .replace(/\bok\b/i, 'OK');
}

/**
 * Map known risk-band keys to their user-facing labels.
 * Falls back to humanizeEnum for unknown keys.
 */
const RISK_LABELS: Record<string, string> = {
  overdue: 'Overdue',
  at_risk: 'At risk',
  ok: 'OK',
  unknown: 'Unknown',
};

export function humanizeRiskBand(band: string): string {
  return RISK_LABELS[band] ?? humanizeEnum(band);
}

/**
 * Decode literal JS unicode escape sequences (e.g. "\\u2264") into real characters.
 * Only processes \\uXXXX patterns (4 hex digits).
 */
export function decodeUnicodeEscapes(input: string): string {
  return input.replace(/\\u([0-9A-Fa-f]{4})/g, (_, hex) =>
    String.fromCharCode(parseInt(hex, 16)),
  );
}

/**
 * Clean any user-facing text: decode unicode escapes, trim, and provide a safe fallback.
 */
export function presentText(input: string | null | undefined, fallback = ''): string {
  if (input == null || input === '') return fallback;
  return decodeUnicodeEscapes(input).trim();
}
